import { render, staticRenderFns } from "./DynamicNotice.vue?vue&type=template&id=25f85d99&"
import script from "./DynamicNotice.vue?vue&type=script&lang=js&"
export * from "./DynamicNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports